import actions from "./actions";

const initState = {
    actions401Queue: [],
    lastApiCallTime: null,
    // lastApiCallObject: {},
};

export default function appReducer(state = initState, action = {}) {
    switch (action.type) {
    /* Number Formats */
        case actions.LOGGER_ENQUEUE_ACTION_401_QUEUE:
            return {
                ...state,
                actions401Queue: state.actions401Queue.concat(action.action),
            };
        case actions.LOGGER_DEQUEUE_ACTION_401_QUEUE:
            return {
                ...state,
                actions401Queue: state.actions401Queue.slice(1),
            };
        case actions.LOGGER_CLEAR_ACTIONS_401_QUEUE:
            return {
                ...state,
                actions401Queue: initState.actions401Queue,
            };
        case actions.LOGGER_LOG_LAST_API_CALL:
            // console.log('aaa LOGGER_LOG_LAST_API_CALL', action);
            return {
                ...state,
                // lastApiCallObject: action.lastApiCallObject,
                lastApiCallTime: action.lastApiCallObject.time,
            };
        case actions.LOGGER_RESET_STATE:
            return {
                ...state,
                actions401Queue: [],
            };
        default:
            return state;
    }
}
